import React from "react";
// import styles from './GoogleMap.module.css'

const GoogleMap = (props) => (
  <iframe
    title={props.title ? props.title : ""}
    width="100%"
    height="100%"
    loading="lazy"
    allowfullscreen
    src={props.address}
  ></iframe>
);

export default GoogleMap;
